import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, unref as _unref } from "vue"

import { computed } from 'vue'

// Components
import { ElTooltip } from 'element-plus'

// i18n
import { useI18n } from 'vue-i18n'
import useThemeClassName from '@/hooks/useThemeClassName'

// Types
import type { Props } from './index'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'HintText',
  props: {
    linkText: {},
    hintText: {},
    tag: { default: 'span' },
    theme: {},
    to: { default: null },
    placement: { default: 'top-start' },
    effect: { default: 'light' }
  },
  setup(__props: any) {

const { t } = useI18n()

// Use
const props = __props

// Computed
const themeClassName = computed(() => useThemeClassName('hint-text', props.theme))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElTooltip), {
    "popper-class": "hint-text__bubble",
    effect: _ctx.effect,
    content: _ctx.hintText,
    placement: _ctx.placement,
    to: _ctx.to
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps({
        class: [themeClassName.value]
      }, _ctx.$attrs, { class: "hint-text" }), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.linkText), 1)
        ]),
        _: 1
      }, 16, ["class"]))
    ]),
    _: 1
  }, 8, ["effect", "content", "placement", "to"]))
}
}

})